<template>
<div class="container-fluid" v-if="$store.state.data.info.bibles.length && $store.state.data.current.chapter.verses.length">
  <div class="bible-open-head">
    <p class="mb-2">
      <span v-if="$store.state.data.index.other">
        &nbsp;
      </span>
      <span v-else>
        {{ $store.state.data.current.book.toc2 }}
        {{ $store.state.data.current.chapter.code }}:{{ $store.state.data.current.verse.code }}
      </span>
    </p>
  </div>
  <div class="row no-gutters bible-open-body">
    <b-list-group class="w-100">
      <b-list-group-item>
        <p class="m-0 px-1 bible-text bible-text-show-all" v-html="html"></p>
        <b-form-textarea
          id="textarea-for-copy"
          v-model="text"
          style="display: none !important"
          @copy.native="onCopyNativeTextAreaForCopy"
          ></b-form-textarea>
        <b-button variant="light" class="w-100" @click="onClickCopyVerse">1節コピー</b-button>
      </b-list-group-item>
    </b-list-group>
    <b-tabs
      class="mt-3 w-100"
      content-class="mt-3"
      >
      <b-tab active>
        <template slot="title">
          <i class="far fa-fw fa-tags text-dark"></i>
        </template>
        <div class="d-flex w-100 justify-content-between">
          <h6 class="mb-2">
            <span>引照・注</span>
          </h6>
        </div>
        <div v-for="note in $store.state.data.current.chapter.notes" v-if="note.target === target">
          <dl class="dl-note m-0">
            <dt class="px-1" v-html="note.index"></dt>
            <dd class="m-0 px-1" v-html="note.value"></dd>
          </dl>
        </div>
        <template v-for="alt in $store.state.data.current.chapter.alts" v-if="alt.target === target">
          <div class="d-flex w-100 justify-content-between">
            <h6 class="mt-4">
              <span>底本に節が欠けている箇所の異本による訳文</span>
            </h6>
          </div>
          <p class="m-0 px-1 bible-text bible-text-show-all" v-html="alt.value"></p>
          <b-button variant="light" class="w-100" @click="onClickLastVerse">書末尾へ移動</b-button>
        </template>
      </b-tab>
      <b-tab class="position-relative">
        <template slot="title">
          <i class="far fa-fw fa-user-edit text-dark"></i>
        </template>
        <div class="d-flex w-100 justify-content-between">
          <h6 class="mb-2">
            <span>スタディ注</span>
          </h6>
        </div>
        <div v-for="study in $store.state.data.current.chapter.documents.study" v-if="(!$store.state.data.index.other && study.verse_code === $store.state.data.current.verse.code) || ($store.state.data.index.other && text && text.match(/^[0-9A-E]+$/) && study.verse_code === '')">
          <dl class="dl-study m-0">
            <dd class="m-0 px-1" v-text="study.memo"></dd>
          </dl>
        </div>
        <p>
        </p>
        <app-buy-layer ticket="premium" variant="white" />
      </b-tab>
      <b-tab v-if="parallel" class="position-relative">
        <template slot="title">
          <i class="far fa-fw fa-list text-dark"></i>
        </template>
        <p class="bible-text">
          <template v-if="parallel.SI && $store.state.data.index.bible != 'SI'">
            <h6>{{ parallel.SI.name }}</h6>
            <p class="mb-3"><span v-for="verse in parallel.SI.verses">{{ verse.text }} </span></p>
          </template>
          <template v-if="parallel.NI && $store.state.data.index.bible != 'NI'">
            <h6>{{ parallel.NI.name }}</h6>
            <p class="mb-3"><span v-for="verse in parallel.NI.verses">{{ verse.text }} </span></p>
          </template>
          <template v-if="parallel.JC && $store.state.data.index.bible != 'JC'">
            <h6>{{ parallel.JC.name }}</h6>
            <p class="mb-3"><span v-for="verse in parallel.JC.verses">{{ verse.text }} </span></p>
          </template>
          <template v-if="parallel.ES && $store.state.data.index.bible != 'ES'">
            <h6>{{ parallel.ES.name }}</h6>
            <p class="mb-3"><span v-for="verse in parallel.ES.verses">{{ verse.text }} </span></p>
          </template>
        </p>
        <app-buy-layer ticket="premium" variant="white" />
      </b-tab>
    </b-tabs>
  </div>
</div>
</template>

<script>
import jQuery from 'jquery'
import { textify, } from '@/utils/tool'
import AppBuyLayer from '@/components/AppBuyLayer.vue'

export default {
  components: {
    AppBuyLayer,
  },
  data: function () {
    return {
      html: null,
      text: null,
      target: null,
      parallel: null,
      last_verse: null,
    }
  },

  methods: {
    onShown(event) {
      if (this.$store.state.data.index.other) {
          const $html = jQuery(this.$store.state.data.index.other)
          const htmlText = $html.text()

          // html
          this.html = $html.prop('outerHTML')

          // text
          this.text = textify(this.html)

          // target
          this.target = $html.attr('index') ? $html.attr('index') : this.html
      } else {
          const $html = jQuery('a.v[active=true]')

          // html
          this.html = ''
          for (let i = 0; i < $html.length; i++) {
            const $item = jQuery($html[i])
            this.html += $item.html() + '<br>'
          }

          // text
          this.text = this.$store.state.data.current.verse.text

          // target
          this.target = this.$store.state.data.current.verse.code

          // parallel
          this.parallel = {}
          this.$store.dispatch('dataBibleVerse', this.$store.state.data.index)
            .then((response) => {
              this.parallel = Object.assign({}, response.data)
            })

          // last_verse
          this.last_verse = {}
          this.$store.dispatch('dataBibleLastVerse', this.$store.state.data.index)
            .then((response) => {
              this.last_verse = Object.assign({}, response.data)
            })
      }
      this.html = this.html.trim().replace(/^<br>/, '').replace(/<br>$/, '')
    },

    onHidden(event) {
      this.$store.dispatch('dataSetIndex', {
        indexes: {
          other: null,
        },
      })
    },

    onClickCopyVerse(event) {
      const textarea = document.getElementById('textarea-for-copy')
      const style = textarea.attributes.style.value
      textarea.style.display = ''

      // for not ios
      textarea.select()
      // for ios
      textarea.setSelectionRange(0, textarea.value.length)

      document.execCommand('copy')
      textarea.style.display = 'none'
    },

    onCopyNativeTextAreaForCopy(event) {
      event.stopPropagation()
    },

    onClickLastVerse(event) {
      this.$store.dispatch('uiToggleModalBibleAction', false)
      this.$store.dispatch('dataBibleOpenWithIndex', {
        bible: this.last_verse.bible_code,
        book: this.last_verse.bible_book_code,
        chapter: this.last_verse.chapter_order,
        verse: this.last_verse.order,
        pushHistory: true,
      })
    },
  },

  created: function() {
  },

  beforeDestroy: function () {
  }
}
</script>

<style lang="scss">
.bible-open-body {
  .tabs {
    height: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;

    .card-header {
      .nav-tabs {
        display: flex;

        li.nav-item {
          flex-grow: 1;

          a.nav-link {
            text-align: center;

            &.active {
              border-color: #dee2e6;
            }
          }
        }
      }
    }

    .tab-content {
      flex-grow: 1;
      overflow-y: scroll;

      .tab-pane {
        .row {
          .card {
            .card-body {
              padding: 1em 0;
              height: 4.5em;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.75em;
            }
          }

          .card {
            .card-body {
              padding: 1em 0;
              height: 4.5em;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.75em;
            }
          }
        }
      }
    }
  }
}
</style>

